/*       */

import { gql } from '@apollo/client';

export default (extraQueryFields) => gql`
    query relationDefinitionAutocompleteQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: relationDefinitions(filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy, startIndex: $startIndex, stopIndex: $stopIndex) {
            id
            type
            description
            relatedType
            relatedDescription
            ${extraQueryFields || ''}
        }
    }
`;
